import { palette } from 'cds/styles';
import { FC } from 'react';
import styled from 'styled-components';

const Section10: FC = () => {
  return (
    <L_Section6>
      <L_Section6_T_Content>
        <span>무료로 상담받고,</span>
        <br />

        <span>클래스유에서 고민을 해결하세요.</span>
      </L_Section6_T_Content>
      <L_Section6_B_ContentContainer>
        <L_Section6_B_Content>
          <span>문의를 남겨주시면,</span>
          <br />
          <span>가능한 빠르게 연락드리겠습니다.</span>
        </L_Section6_B_Content>
      </L_Section6_B_ContentContainer>
    </L_Section6>
  );
};

export default Section10;

const L_Section6 = styled.section`
  text-align: center;
`;

const L_Section6_T_Content = styled.div`
  font-weight: 600;
  font-size: 2.4rem;
  margin-top: 10rem;
  color: ${palette.grey75};
`;
const L_Section6_B_ContentContainer = styled.div`
  margin-top: 3.2rem;
`;
const L_Section6_B_Content = styled.div`
  font-weight: 300;
  font-size: 1.6rem;
  color: ${palette.grey50};
`;
